import http from '../_http'

const sub = {
  //default
  summarySub: (m) => { return http.get(`manager/billing/subscription`, m); },
  listSub: (m) => { return http.post(`manager/billing/subscription/list`, m); },
  detailSub: (m) => { return http.get(`manager/billing/subscription/${m.id}`); },

  //crud
  insertSub: (m) => { return http.post(`manager/billing/subscription`, m); },
  updateSub: (m) => { return http.put(`manager/billing/subscription`, m); },
  deleteSub: (m) => { return http.delete(`manager/billing/subscription/${m.id}`); },
}

export default sub

export { sub }